import cn from 'classnames';
import { forwardRef } from 'react';

import type { Button, ButtonProps } from '@sravni/react-design-system/dist/types/components/Button';
import { Layout } from '@sravni/react-design-system/lib/Layout';

import { AnchorButton } from 'features/ProductList/ui/AnchorButton';

import styles from './MoreButton.module.scss';

export const MoreButton = forwardRef<typeof Button, ButtonProps & { text: string }>(({ className, text, onClick }) => (
  <Layout className={styles.layout}>
    <AnchorButton text={text} onClick={onClick} />
  </Layout>
));
